import React from "react";

const InsuranceTerritoryWarningIcon = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true" {...props}>
    <path
      transform="translate(1.667 1.667)"
      d="M8.294 0C3.721 0 0 3.738 0 8.333C0 12.928 3.738 16.667 8.333 16.667C12.928 16.667 16.667 12.928 16.667 8.333C16.667 3.738 12.911 0 8.294 0ZM8.333 15C4.657 15 1.667 12.009 1.667 8.333C1.667 4.657 4.639 1.667 8.294 1.667C11.993 1.667 15 4.657 15 8.333C15 12.009 12.009 15 8.333 15Z"
      fill="currentColor"
    />
    <path
      transform="translate(9.167 5.833)"
      d="M0 0L1.667 0L1.667 5.833L0 5.833L0 0ZM0 6.667L1.667 6.667L1.667 8.333L0 8.333L0 6.667Z"
      fill="currentColor"
    />
  </svg>
);

export default InsuranceTerritoryWarningIcon;
